@if (show && config) {
  <div class="promo-banner" [style.background]="config.bg_color" [style.top.px]="stickyTop">
    <div class="promo-banner__content">
      <mat-icon class="promo-banner__icon" [fontSet]="config.icon_font" [style.color]="config.icon_color">{{ config.icon }}</mat-icon>
      <span class="promo-banner__text" [style.color]="config.text_color">
        {{ config.text_prefix }}<strong>{{ config.text_bold }}</strong>{{ config.text_suffix }}
      </span>
    </div>
    <div class="promo-banner__actions">
      <button
        class="promo-banner__button"
        [style.background]="config.button_bg_color"
        [style.color]="config.button_text_color"
        (click)="on_download_click()">
        {{ config.button_label }}
      </button>
      <button class="promo-banner__close" [style.color]="config.text_color" (click)="on_dismiss()" aria-label="Cerrar">
        &times;
      </button>
    </div>
  </div>
}
